<template>
  <div>
    <section class="modal-body">
      <h1>Would you like to switch your provider for the next service?</h1>
    </section>
    <footer class="modal-footer">
      <LsButton
        text="NO"
        track-id="return_request_redistribution-no"
        test-id="no"
        bg-color="primary-light"
        text-color="primary"
        @click="onSubmit({ redistribute: false })"
      />
      <LsButton
        text="YES"
        test-id="yes"
        track-id="return_request_redistribution-yes"
        bg-color="tertiary"
        @click="onSubmit({ redistribute: true })"
      />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapState, mapActions } from 'vuex';
import { DISPUTES_REDISTRIBUTE, DISPUTE__UPDATE_CURRENT_DISPUTE } from '../../../store/types';
import moment from 'moment';

export default {
  name: 'ReturnRequestRedistribute',
  components: {
    LsButton,
  },
  data() {
    return {
      updating: false,
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([DISPUTES_REDISTRIBUTE, DISPUTE__UPDATE_CURRENT_DISPUTE]),
    onSubmit({ redistribute }) {
      if (this.updating) {
        return;
      }
      this.updating = true;
      let redistribution_accepted_at = null;
      if (redistribute) {
        this[DISPUTES_REDISTRIBUTE]();
        redistribution_accepted_at = moment().format('YYYY-DD-MM');
      }
      this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
        currentStep: 'ReturnRequestCreditApplied',
        redistribution_accepted_at,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  button:first-of-type {
    margin-right: 5px;
  }

  button:last-of-type {
    margin-left: 5px;
  }
}
</style>
